<template lang="html">
  <v-layout column justify-center align-center style="height: 100vh;">
    <v-progress-circular width="8" :size="90" color="primary" :indeterminate="progress" v-if="progress"></v-progress-circular>
  </v-layout>
</template>

<script>
import { Encode } from '@/services'
var _ = require('lodash')
export default {
  data () {
    return {
      progress: true,
      tokenuser: ''
    }
  },
  created () {
    this.getAuthen(this.$route.query.token)
  },
  methods: {
    getAuthen (authen) {
      // console.log(`authen: ${authen}`)
      // console.log(Encode.encodeToken('Uba7cb86c384f5fa5b3eae7269b4993ce'))
      // this.$router.push('/homepagemobile')
      // this.$router.push('/account/B150e5db5d81a51d29f34b95f21804b50')
      localStorage.clear()
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/login_onechat_token', { source: authen }).then((response) => {
        if (response.data.status === 'success') {
          localStorage.setItem('status_login', 'T')
          localStorage.setItem('profilepicture', response.data['account']['profile']['profilepicture'])
          localStorage.setItem('tokenservice', Encode.encodeToken(response.data['account']['profile']['tokenservice']))
          localStorage.setItem('tokenuser', Encode.encodeToken(response.data['account']['profile']['tokenuser']))
          localStorage.setItem('name', response.data['account']['profile']['name'])
          localStorage.setItem('phone', response.data['account']['profile']['phone'])
          localStorage.setItem('email', response.data['account']['profile']['email'])
          localStorage.setItem('status', response.data['account']['profile']['status'])
          // location.pathname = '/profile'
          // this.$router.push('/homepage')
          this.getlistbot(response.data['account']['profile']['tokenuser'])
        } else {
          this.$swal({ title: 'ไม่สามารถเข้าใช้งานได้ กรุณาลองใหม่ภายหลัง', type: 'warning' })
          localStorage.setItem('status_login', 'F')
        }
      }).catch(error => {
        console.log(error)
      })
    },
    getlistbot (tokenuser) {
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/web/getlistbot', { tokenuser: tokenuser }).then((response) => {
        if (response.data.message === 'success') {
          var listbot = response.data.listbot
          if (listbot.length !== 0) {
            listbot = _.orderBy(listbot, ['nickname'], ['asc'])
            localStorage.setItem('tokenbot', listbot[0].tokenuser)
            // this.$router.push('/account/' + listbot[0].tokenuser)
            this.$router.push(`/listchat/${listbot[0].tokenuser}`)
          } else {
            this.$router.push('/homepage-mobile')
          }
        }
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
